const PreSaleType = {
    // add milstones
    GET_PRE_SALE_FIRST: "GET_PRE_SALE_FIRST",
    GET_PRE_SALE_LOADING: "GET_PRE_SALE_LOADING",
    GET_PRE_SALE_SUCCESS: "GET_PRE_SALE_SUCCESS",
    GET_PRE_SALE_RESET: "GET_PRE_SALE_RESET",
    GET_PRE_SALE_ERROR: "GET_PRE_SALE_ERROR",

    ADD_PRE_SALE_FIRST: "ADD_PRE_SALE_FIRST",
    ADD_PRE_SALE_LOADING: "ADD_PRE_SALE_LOADING",
    ADD_PRE_SALE_SUCCESS: "ADD_PRE_SALE_SUCCESS",
    ADD_PRE_SALE_RESET: "ADD_PRE_SALE_RESET",
    ADD_PRE_SALE_ERROR: "ADD_PRE_SALE_ERROR",

    UPDATE_PRE_SALE_FIRST: "UPDATE_PRE_SALE_FIRST",
    UPDATE_PRE_SALE_LOADING: "UPDATE_PRE_SALE_LOADING",
    UPDATE_PRE_SALE_SUCCESS: "UPDATE_PRE_SALE_SUCCESS",
    UPDATE_PRE_SALE_RESET: "UPDATE_PRE_SALE_RESET",
    UPDATE_PRE_SALE_ERROR: "UPDATE_PRE_SALE_ERROR",
    
    DELETE_PRE_SALE_FIRST: "DELETE_PRE_SALE_FIRST",
    DELETE_PRE_SALE_LOADING: "DELETE_PRE_SALE_LOADING",
    DELETE_PRE_SALE_SUCCESS: "DELETE_PRE_SALE_SUCCESS",
    DELETE_PRE_SALE_RESET: "DELETE_PRE_SALE_RESET",
    DELETE_PRE_SALE_ERROR: "DELETE_PRE_SALE_ERROR",
};

export default PreSaleType;
